import "./dynamicScriptsLoader.js";

// Handle error - Failed to fetch dynamically imported module
// window.addEventListener("unhandledrejection", (event) => {
//     const message = event.reason?.message || "";

//     if (message.includes("Failed to fetch dynamically imported module")) {
//         event.preventDefault();
//         window.location.reload();
//     }
// });

// Handle error - Importing a module script failed
// window.addEventListener("error", (event) => {
//     const message = event.message || "";

//     if (message.includes("Importing a module script failed")) {
//         event.preventDefault();
//         window.location.reload();
//     }
// });

(async () => {
    await window.loadScript("InteractionScriptsLoader.js");

    if (import.meta.env.CO_SENTRY_ENABLED === "true") {
        window.snakeCheckout.Sentry = await window.loadScript("@sentry/browser");
        window.snakeCheckout.Sentry.init({
            dsn: import.meta.env.CO_SENTRY_DSN,
            environment: import.meta.env.CO_SENTRY_ENV,
            // replaysOnErrorSampleRate: 0.2,
            normalizeDepth: 4,
            sendDefaultPii: true,
            integrations: [
                window.snakeCheckout.Sentry.httpClientIntegration(),
                window.snakeCheckout.Sentry.extraErrorDataIntegration(),
                // Sentry.captureConsoleIntegration()
            ],
            beforeSend: (event) => {
                // enrich every event (handled and unhandled) with the live checkout state; must never throw or the event is dropped
                try {
                    event.contexts = {
                        ...event.contexts,
                        checkout: {
                            iod: window.snakeCheckout?.iod ?? "missing",
                            cart_id: window.snakeCheckout?.initData?.cartId ?? "missing",
                            gigyaId: window.snakeCheckout?.accountInfo?.gigyaId ?? "missing",
                            params: window.location?.search,
                            payment_type: window.snakeCheckout?.paymentMethod ?? window.snakeCheckout?.Storage?.get("payment_method") ?? "missing",
                        },
                    };

                    if (window.snakeCheckout?.accountInfo?.gigyaId) event.user = { ...event.user, id: window.snakeCheckout.accountInfo.gigyaId };
                } catch (e) {
                    window.snakeCheckout?.Trace?.warn("[error] Sentry beforeSend enrichment failed", e);
                }

                return event;
            },
        });
    }
})();

// FIX "Can't find variable: _AutofillCallbackHandler" - https://developers.facebook.com/community/threads/320013549791141/
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function () {};

document.addEventListener("DOMContentLoaded", async () => {
    window.snakeCheckout.Storage = await window.loadScript("snake.lib.storage.js");

    const traceEnabled = window.snakeCheckout.Storage.get("debug") === "1" || (import.meta.env.CO_SENTRY_ENV !== "deagostini_production" && import.meta.env.CO_SENTRY_ENV !== "fanhome_production" && import.meta.env.CO_SENTRY_ENV !== "deagostini_production_b" && import.meta.env.CO_SENTRY_ENV !== "fanhome_production_b");
    window.snakeCheckout.Trace = await window.loadScript("snake.lib.trace.js");
    window.snakeCheckout.Trace.enabled = traceEnabled;

    await window.loadScript("checkout.js").then((Checkout) => Checkout.init());
});
